/**
 * @file components/boostDisplay.js
 * @description One display map for the boosts an agency buys with credits: name, one-line description, icon and
 *   accent color. Used by the Billing credits card and RankReceipt. Costs are NOT here: they come from
 *   lib/boostService.getBoostProducts (platform_config).
 * @module components/boostDisplay
 */
import { StarIcon, ClockIcon, TargetIcon, ZapIcon, MegaphoneIcon } from "./Icons";

export const BOOST_DISPLAY = {
  spotlight:        { nameKey: "billing.boostNameSpotlight",       descKey: "billing.boostDescSpotlight",    icon: StarIcon,      accent: "#6D28D9" },
  bundle:           { nameKey: "billing.boostNameFastFillBundle",  descKey: "billing.boostDescBundle",       saveDescKey: "billing.boostDescBundleSave",       icon: ZapIcon,       accent: "#059669" },
  urgency_badge:    { nameKey: "billing.boostNameUrgentBadge",     descKey: "billing.boostDescUrgency",      icon: ClockIcon,     accent: "#DC2626" },
  candidate_expand: { nameKey: "billing.boostNameExpandRadius",    descKey: "billing.boostDescExpand",       icon: TargetIcon,    accent: "#0284C7" },
  reach_blast:      { nameKey: "billing.boostNameReachBlast",      descKey: "billing.boostDescReachBlast",   icon: MegaphoneIcon, accent: "#D97706" },
};

/** The order boosts are listed in on Billing. */
export const BOOST_MENU = ["spotlight", "bundle", "urgency_badge", "candidate_expand", "reach_blast"];
